import { useState, useEffect } from 'react';

export function useDynamicMenu(siteData, menu) {
    const [dynamicMenu, setDynamicMenu] = useState(menu);

    useEffect(() => {
        if (siteData.selectedStore.store) {
            // if a store is selected
            let metro = siteData.selectedStore.metro;
            let store = siteData.selectedStore.store;
            const urlParts = store.urlPath.split('/');
            const metroUrl = urlParts.slice(0, -1).join('/');

            let toBeInjected = {
                link: `${metro.name} Locations`,
                pathname: metroUrl,
                hasValidPath: true,
            };
            if (menu[3].items[0].pathname === '/locations/') {
                menu[3].items.unshift(toBeInjected); // Inject a new link
            } else {
                menu[3].items[0] = toBeInjected; // Replace the current link
            }
            setDynamicMenu([...menu]);
        } else if (!siteData.selectedStore.store && menu[3].items[0].pathname !== '/locations/') {
            // if no store is selected
            menu[3].items.shift();
            setDynamicMenu([...menu]);
        }
    }, [siteData.selectedStore]);

    return [...dynamicMenu];
}

export default useDynamicMenu;
